import { render, staticRenderFns } from "./image-pin-area.vue?vue&type=template&id=096ce991&scoped=true"
import script from "./image-pin-area.vue?vue&type=script&lang=js"
export * from "./image-pin-area.vue?vue&type=script&lang=js"
import style0 from "./image-pin-area.vue?vue&type=style&index=0&id=096ce991&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096ce991",
  null
  
)

export default component.exports